export { ProductGallery } from "./ProductGallery";
export type {
	ProductGalleryProps,
	ProductGallerySlide
} from "./ProductGallery";
